define.alias("shared/utils/upgrade/choose-your-upgrade", "media/utils/upgrade/choose-your-upgrade");